import { createSelector } from "reselect";

import { TableColumnMeta } from "ds/components/Table/types";

import { TableColumnsState, TableSettingsConfig } from "./types";

export const selectVisibleColumns = createSelector(
  (state: TableColumnsState) => state.columnsState,
  (state: TableColumnsState) => state.columnsOrder,
  (columnsState, columnsOrder): TableColumnMeta[] => {
    return columnsOrder.visible.reduce<TableColumnMeta[]>((acc, columnId) => {
      const column = columnsState[columnId];
      if (column) {
        acc.push(column);
      }
      return acc;
    }, []);
  }
);

export const selectTableSettingsConfig = createSelector(
  (state: Pick<TableColumnsState, "columnsState" | "columnsOrder">) => state.columnsState,
  (state: Pick<TableColumnsState, "columnsState" | "columnsOrder">) => state.columnsOrder,
  (columnsState, columnsOrder): TableSettingsConfig => {
    return {
      visibleColumns: columnsOrder.visible.filter((columnId) => !!columnsState[columnId]),
      hiddenColumns: columnsOrder.hidden.filter((columnId) => !!columnsState[columnId]),
      nonConfigurableColumns: Object.keys(columnsState).filter(
        (columnId) => columnsState[columnId].configurable === false
      ),
    };
  }
);

export const selectColumnSize = createSelector(
  (state: TableColumnsState, columnId: string) => state.columnsSizes[columnId],
  (result): number | undefined => result
);
